import { useState } from "react";
import "./input-box.css";
const InputBox = ({ id, label, type, name, value, active, isDisabled }) => {
  const [isFocus, setIsFocus] = useState(false);
  const handleFocus = () => {
    setIsFocus(true);
  };
  const handleBlur = (e) => {
    if (!e.target.value) setIsFocus(false);
  };
  return (
    <div className={`input_box ${isFocus ? "active" : null}`}>
      <label className={isFocus || active ? "active" : null} htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        type={type}
        name={name}
        onFocus={handleFocus}
        onBlur={handleBlur}
        defaultValue={value}
        disabled={isDisabled}
      />
    </div>
  );
};
export default InputBox;
